module.exports = __webpack_public_path__ + "img/toren.206b6375.png";